import { ISelectorRequires } from 'constants/types';
import { FilterSearchbarWrapper } from 'pages/Setting/common/style';
import { UseFormReturn } from 'react-hook-form';
import { Selector } from 'components/Timeline/components/Selector';
import { ReactComponent as IcMagnifyingGlass } from 'constants/icon/ic_magnifyingglass.svg';
import { ReactComponent as IcRemove } from 'constants/icon/input_remove.svg';
import styled from 'styled-components';
import { Stack } from 'components/Stack';
import { IRequestParams } from 'pages/Message/History/HistoryStore';

interface IProps<T> {
  methods: UseFormReturn<Partial<T>>;
  content: Array<ISelectorRequires<string> & { placeholder?: string }>;
}

export const FilterSearchbar = ({ methods, content }: IProps<IRequestParams>) => {
  return (
    <FilterSearchbarWrapper className="filter-searchbar-wrapper" direction="row" style={{ width: '360px' }}>
      <Selector
        displayKey={methods.watch('keywordType')}
        width={80}
        extension={126}
        scrollCriteria={32 * 6 + 2}
        gap={13}
        outline={false}
        fill={false}
        onClick={(e, v) => {
          methods.setValue('keywordType', v.value);
        }}
        options={content}
      />

      <SearchbarInputContainer
        spacing={4}
        direction="row"
        justify="space-between"
        isFilled={!!(methods.watch('keyword') && methods.watch('keyword') !== '')}
      >
        <IcMagnifyingGlass
          className="spyglass"
          width={16}
          height={16}
          onClick={() => {
            //need to add form action
          }}
        />
        <input
          {...methods.register('keyword', {})}
          autoComplete="off"
          placeholder={(() => {
            const placeholder = content.find(x => x.value === methods.watch('keywordType'))?.placeholder;
            return placeholder ?? '';
          })()}
        />
        {(methods.watch('keyword') ?? '').length > 0 && (
          <IcRemove
            tabIndex={-1}
            className="removeBtn"
            width={16}
            height={16}
            onClick={() => {
              methods.resetField('keyword');
            }}
          />
        )}
      </SearchbarInputContainer>
    </FilterSearchbarWrapper>
  );
};

export const SearchbarInputContainer = styled(Stack)<{ isFilled: boolean }>`
  padding: 6px 16px 6px 10px;

  & > input {
    width: 100%;
    background: transparent;

    ::placeholder {
      color: ${({ theme }) => theme.colors.RG04};
      font-size: 13px;
    }
  }

  /* & > svg {
      cursor: pointer;
    } */

  & > .removeBtn {
    display: none;
    cursor: pointer;
    margin-right: -8px;
  }

  & > .spyglass > path {
    stroke: ${({ theme }) => theme.colors.RG04};
  }

  :focus-within {
    & > .spyglass {
      width: 0;
      transition: all 0.4s;
    }

    & > .removeBtn {
      display: block;
    }
  }

  ${({ isFilled }) =>
    isFilled && {
      '& > .spyglass': {
        width: 0,
        transition: 'all 0.4s',
      },
    }}
`;
